export default __webpack_public_path__ + "static/media/VERY_LOA.573a5793.pdf";